/**
 * CheckoutOptions.js — "Ship or Pickup?" step (kind "checkout-options").
 *
 * Parity with old showCheckoutOptions (script.js 3493): bot avatar + question
 * bubble + [Ship] [Pickup] chips (same row layout as TextBubble). Pure UI —
 * clicking a chip emits ws-checkout-method by default; features/optional/
 * checkout.js (Fogarty/Wine Engine "split" flow) or checkout_c7.js's
 * "reviewed" flow (Lightning Rock/Potter's/Valle carts) owns the next step.
 *
 * message.data.eventName overrides that emitted event — club_c7.js passes
 * "ws-club-checkout-method" so its own Ship/Pickup step (same component,
 * different flow) doesn't also fire checkout_c7.js's reviewed-flow handler,
 * which listens on the default event name unconditionally (no session guard
 * of its own) and would otherwise add a second, unrelated checkout-form.
 *
 * message.data.question overrides the bubble text — club_c7.js re-shows this
 * step from the Edit pencil (an already-delivered-type order asking to
 * confirm/switch it), where the default first-ask wording ("Would you like
 * your order shipped...") reads wrong; it passes "Change delivery type?" there.
 */

import { emit, addMessage } from "../../../core/state.js";
import { getTheme } from "../../../core/configAccessors.js";
import { getDefaultBotAvatar } from "./avatars.js";

const QUESTION =
  "Would you like your order shipped to you, or would you prefer to pick it up?";

export default class CheckoutOptions {
  render(message) {
    const eventName = message?.data?.eventName || "ws-checkout-method";
    const question = message?.data?.question || QUESTION;
    const row = document.createElement("div");
    row.className = "ws-bot-row ws-checkout-options ws-fr";

    const avatar = document.createElement("div");
    avatar.className = "ws-avatar ws-bot-avatar";
    const url = getTheme("bot_avatar_url", null);
    if (url) {
      const img = document.createElement("img");
      img.src = url;
      img.alt = "";
      img.onerror = () => {
        avatar.innerHTML = getDefaultBotAvatar();
      };
      avatar.appendChild(img);
    } else {
      avatar.innerHTML = getDefaultBotAvatar();
    }
    row.appendChild(avatar);

    const wrap = document.createElement("div");
    wrap.className = "ws-bubble-wrap";

    const bubble = document.createElement("div");
    bubble.className = "ws-bot-bubble";
    bubble.textContent = question;
    wrap.appendChild(bubble);

    const chips = document.createElement("div");
    chips.className = "ws-checkout-chips";
    const buttons = [];
    [
      ["Ship", "ship"],
      ["Pickup", "pickup"],
    ].forEach(([label, type]) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ws-cart-action-btn";
      btn.textContent = label;
      btn.addEventListener("click", () => {
        this._selectOption(btn, buttons);
        emit(eventName, { type });
      });
      buttons.push(btn);
      chips.appendChild(btn);
    });
    wrap.appendChild(chips);

    row.appendChild(wrap);
    return row;
  }

  _selectOption(button, buttons) {
    button.classList.add("is-selected");
    buttons.forEach((item) => (item.disabled = true));
  }
}
